export const siteMeta = {
  name: "炮渣漫画网",
  slogan: "翻译对比看清删页差异，只看舒服版本",
  tagline: "神翻译合集 · 润色版推荐 · 烂翻译避雷",
};

export interface MangaItem {
  id: number;
  title: string;
  jpTitle: string;
  category: string;
  tags: string[];
  rating: number;
  status: string;
  quote: string;
  image: string;
  desc: string;
  note: string;
}

export interface AvoidItem {
  id: number;
  title: string;
  version: string;
  reasons: string[];
  grade: string;
  scene: string;
  image: string;
  redline: string;
}

export interface CompareItem {
  id: number;
  title: string;
  editions: string[];
  result: string;
  image: string;
  points: string[];
}

export const godTranslations: MangaItem[] = [
  {
    id: 1,
    title: "街角的面包房",
    jpTitle: "街角のパン屋さん",
    category: "治愈日常",
    tags: ["神翻译", "润色版推荐", "方言韵味"],
    rating: 9.6,
    status: "全 32 话 · 已完结",
    quote: "「今天的面包，是替你留着的那份。」",
    image: "https://readdy.ai/api/search-image?query=cozy%20japanese%20bakery%20interior%20with%20warm%20golden%20light%2C%20fresh%20bread%20on%20wooden%20counter%2C%20gentle%20slice%20of%20life%20manga%20cover%20illustration%20style%2C%20soft%20watercolor%20tones%2C%20warm%20cream%20and%20terracotta%20palette%2C%20minimal%20clean%20composition&width=800&height=1000&seq=paozha-god-1&orientation=portrait",
    desc: "这部治愈系的润色版堪称教科书级：译文保留日式含蓄，又用中文日常口语自然转译，情绪颗粒度极细。",
    note: "推荐读「暖炉汉化」润色版，细节处理最贴原作情绪。",
  },
  {
    id: 2,
    title: "夏日倒数",
    jpTitle: "夏のカウントダウン",
    category: "青春恋爱",
    tags: ["神翻译", "嵌字漂亮", "氛围到位"],
    rating: 9.4,
    status: "全 24 话 · 已完结",
    quote: "「蝉声落下的时候，我突然不想让你走了。」",
    image: "https://readdy.ai/api/search-image?query=youthful%20summer%20manga%20cover%20illustration%2C%20two%20teenagers%20at%20sunset%20on%20country%20road%2C%20electric%20poles%20and%20cicada%20season%2C%20warm%20orange%20and%20golden%20sky%2C%20nostalgic%20clean%20illustration%2C%20soft%20shadows&width=800&height=1000&seq=paozha-god-2&orientation=portrait",
    desc: "翻译把青春的笨拙与心动都译出来了，嵌字字号、气泡走向与分镜完全贴合，读起来像在看原作。",
    note: "嵌字师「纸鸢」的版本被多次转载，是目前公认最舒服的一版。",
  },
  {
    id: 3,
    title: "铁轨上的旅人",
    jpTitle: "線路の旅人",
    category: "公路群像",
    tags: ["神翻译", "删页对比", "无删减"],
    rating: 9.2,
    status: "连载中 · 48 话",
    quote: "「每一站都有人下车，可终点始终是你。」",
    image: "https://readdy.ai/api/search-image?query=lonely%20traveler%20with%20suitcase%20on%20empty%20railway%20platform%20at%20dusk%2C%20manga%20illustration%20style%2C%20long%20shadows%2C%20warm%20amber%20and%20ink%20tones%2C%20cinematic%20wide%20shot%2C%20minimal%20composition&width=800&height=1000&seq=paozha-god-3&orientation=portrait",
    desc: "这一组被列入神翻译的原因之一是无删减：全 48 话一页未动，连作者后记都完整保留。",
    note: "相比某平台版删掉了 7 处关键分镜，无删减版体验天差地别。",
  },
  {
    id: 4,
    title: "深夜食堂·续",
    jpTitle: "真夜中の食堂",
    category: "美食群像",
    tags: ["神翻译", "菜单考据", "注释丰富"],
    rating: 9.5,
    status: "全 40 话 · 已完结",
    quote: "「关东煮的萝卜，要炖足一晚才肯把甜味交出来。」",
    image: "https://readdy.ai/api/search-image?query=nocturnal%20japanese%20izakaya%20food%20stall%20steaming%20at%20night%2C%20warm%20lantern%20light%2C%20odens%20and%20food%20manga%20illustration%2C%20cozy%20dark%20background%20with%20warm%20glow%2C%20appetizing%20detail&width=800&height=1000&seq=paozha-god-4&orientation=portrait",
    desc: "汉化组对每道菜做了考据注释，把日本饮食文化背景补得明明白白，读着像看美食纪录片。",
    note: "菜单名称采用「菜名+注释」双轨处理，既保留原意又方便理解。",
  },
];

export const avoidWorks: AvoidItem[] = [
  {
    id: 1,
    title: "机械狂潮",
    version: "某速翻平台版",
    reasons: ["机翻痕迹严重，句意经常连不上", "人物名字前后不统一", "删掉了 3 处关键战斗分镜"],
    grade: "重度避雷",
    scene: "第 12 话",
    image: "https://readdy.ai/api/search-image?query=mecha%20manga%20cover%20illustration%20with%20dark%20industrial%20robot%2C%20cold%20metallic%20tones%2C%20dramatic%20lighting%2C%20high%20contrast%2C%20energetic%20linework%2C%20gritty%20texture&width=800&height=1000&seq=paozha-avoid-1&orientation=portrait",
    redline: "「他把她杀了」翻成「他把她杀了」（前后文语境完全错位），同一人物 3 个译名并存。",
  },
  {
    id: 2,
    title: "月光侦探社",
    version: "通用速翻版",
    reasons: ["推理关键线索被译错", "黑体字风格统一成宋体，语气尽失", "嵌字压到文字框外"],
    grade: "中度避雷",
    scene: "第 5 话 · 第 18 话",
    image: "https://readdy.ai/api/search-image?query=noir%20detective%20manga%20cover%20illustration%2C%20moonlit%20city%20silhouette%2C%20magnifying%20glass%20and%20trench%20coat%2C%20blue%20night%20mood%20with%20ink%20shadows%2C%20mysterious%20clean%20composition&width=800&height=1000&seq=paozha-avoid-2&orientation=portrait",
    redline: "推理核心线索「时间顺序」被译反，直接导致读者看谜题一头雾水。",
  },
  {
    id: 3,
    title: "甜度超标",
    version: "热门平台版",
    reasons: ["把吐槽台词删成只剩表情", "大量叠译导致台词被截断", "角色口头禅被统一抹掉"],
    grade: "中度避雷",
    scene: "全篇",
    image: "https://readdy.ai/api/search-image?query=sweet%20romance%20shoujo%20manga%20cover%20illustration%2C%20pastel%20pink%20and%20cream%20tones%2C%20cute%20character%20with%20macarons%2C%20soft%20light%2C%20clean%20minimal%20background&width=800&height=1000&seq=paozha-avoid-3&orientation=portrait",
    redline: "原作的吐槽梗几乎全部被「静音」，读到中段只剩空气甜甜的，笑点全无。",
  },
  {
    id: 4,
    title: "龙与勇者",
    version: "早期速翻版",
    reasons: ["世界观名词翻译不统一", "大量机翻句式", "关键转折页被截成半页"],
    grade: "重度避雷",
    scene: "第 9 话 · 第 21 话",
    image: "https://readdy.ai/api/search-image?query=fantasy%20dragon%20and%20hero%20manga%20cover%20illustration%2C%20epic%20mountain%20landscape%2C%20dragon%20silhouette%2C%20warm%20sunset%20and%20ink%20detail%2C%20adventurous%20dramatic%20lighting&width=800&height=1000&seq=paozha-avoid-4&orientation=portrait",
    redline: "同一世界观名词在不同话出现 5 种译法，读起来像在看两部作品。",
  },
];

export const compareCases: CompareItem[] = [
  {
    id: 1,
    title: "铁轨上的旅人 · 第 3 话",
    editions: ["炮渣无删减版", "某平台版"],
    result: "无删减版胜出",
    image: "https://readdy.ai/api/search-image?query=two%20side%20by%20side%20manga%20pages%20comparison%20concept%2C%20split%20screen%20layout%2C%20railway%20platform%20scene%2C%20warm%20neutral%20background%2C%20clean%20editorial%20graphic&width=1200&height=700&seq=paozha-cmp-1&orientation=landscape",
    points: ["平台版删除了 2 处分镜与 1 处对话", "无删减版完整保留作者留白与情感铺垫", "平台版把一处关键情绪台词改写得过于直白"],
  },
  {
    id: 2,
    title: "机械狂潮 · 第 12 话",
    editions: ["炮渣评测版", "某速翻版"],
    result: "评测版胜出",
    image: "https://readdy.ai/api/search-image?query=mecha%20battle%20scene%20split%20comparison%20graphic%2C%20cool%20industrial%20tones%2C%20editorial%20layout%2C%20before%20and%20after%20translation%20concept&width=1200&height=700&seq=paozha-cmp-2&orientation=landscape",
    points: ["速翻版三处关键对话机翻断句", "评测版补全语气与动作音效", "速翻版人物译名混乱，评测版全程统一"],
  },
  {
    id: 3,
    title: "街角的面包房 · 第 8 话",
    editions: ["润色版推荐", "通用版"],
    result: "润色版胜出",
    image: "https://readdy.ai/api/search-image?query=warm%20bakery%20conversation%20scene%20split%20comparison%2C%20soft%20cream%20tones%2C%20gentle%20light%2C%20editorial%20before%20after%20layout&width=1200&height=700&seq=paozha-cmp-3&orientation=landscape",
    points: ["润色版用自然口语保留情绪，通用版偏书面", "润色版方言词处理贴合作者本意", "通用版把「敬语」层级全部抹平"],
  },
];

export const letteringJabs = [
  {
    id: 1,
    title: "黑体与宋体混用成风",
    body: "很多速翻版为了省事，全篇只用一个宋体字号，喊叫、耳语、内心独白全一个样。原作用黑体强调的爆点，翻出来成了新闻稿。",
    tag: "嵌字吐槽",
  },
  {
    id: 2,
    title: "台词挤爆气泡",
    body: "一行塞十几个字，气泡放不下就往页边溢出，甚至压住画面。读者要在断句里猜语气，体验直接拉胯。",
    tag: "嵌字吐槽",
  },
  {
    id: 3,
    title: "译文比原文还长",
    body: "中文原本比日文精炼，可有的译版反着来，一个词翻成一句解释，把分镜节奏完全打乱，读起来又密又累。",
    tag: "翻译吐槽",
  },
  {
    id: 4,
    title: "拟声词直接消失",
    body: "「咚」「砰」「飒」这类拟声是漫画情绪的放大器，不少版本直接删掉，动作戏瞬间变成哑剧。",
    tag: "嵌字吐槽",
  },
];

export const faqs = [
  {
    q: "「炮渣」是什么意思？为什么叫炮渣漫画网？",
    a: "「炮渣」是我们自嘲的名字——意思是阅本无数、踩过无数雷后留下的「炮灰渣渣」。我们把踩过的坑、看到的雷、挖到的宝都记录在这里，帮你少走弯路。",
  },
  {
    q: "神翻译合集是怎么评选出来的？",
    a: "我们会逐话对比多个版本，从翻译准确度、润色自然度、嵌字排版、删页处理四个维度打分，只收录能完整保留原作情绪与分镜的优秀版本。",
  },
  {
    q: "「删页对比」是什么意思？",
    a: "部分平台版为了压缩内容会删掉关键分镜或对白。我们会截图对比无删减版与平台版，把差异一一标出，让你清楚知道自己少看了什么。",
  },
  {
    q: "避雷区的评级标准是什么？",
    a: "分为「重度避雷」与「中度避雷」两级：重度指机翻严重、删页明显、译名混乱到影响理解；中度指润色欠佳、嵌字粗糙，但尚可读。",
  },
  {
    q: "我也可以投稿吐槽或避雷吗？",
    a: "当然可以。欢迎通过「联系我们」把踩雷经历或宝藏汉化发给我们，经审核后会标注来源收录进对应栏目。",
  },
  {
    q: "这里的链接是盗版资源吗？",
    a: "我们只做汉化质量的评测与推荐，不提供任何盗版资源下载或在线链接。所有点评均基于公开信息与正版/授权内容，尊重原作者的创作。",
  },
];